var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBmi = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16 2H8C5 2 3 4 3 7V17C3 20 5 22 8 22H16C19 22 21 20 21 17V7C21 4 19 2 16 2ZM17.57 8.48L15.39 11.98C15.33 12.07 15.23 12.14 15.13 12.15C15.11 12.15 15.09 12.15 15.08 12.15C14.99 12.15 14.9 12.12 14.83 12.06C13.22 10.63 10.8 10.63 9.19 12.06C9.11 12.13 9 12.17 8.89 12.15C8.78 12.13 8.68 12.07 8.63 11.98L6.45 8.48C6.33 8.33 6.36 8.13 6.5 8C9.63 5.21 14.36 5.21 17.5 8C17.64 8.13 17.67 8.33 17.57 8.48Z",
  fill: "#F4F4F5"
})));
export default SvgBmi;